<template>
  <div class="addContactCount">
    <div class="name">
      {{ moduleTitle }}
    </div>
    <div class="row-one">
      <i class="icon icon-warning"></i>
      <span v-html="topText" class="topText"></span>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleFormAddCount"
      label-width="150px"
    >
      <el-form-item label="程序显示名称" prop="programName">
        <el-input
          v-model="ruleForm.programName"
          :maxlength="32"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="是否启用" prop="isEnable">
        <el-switch
          v-model="ruleForm.isEnable"
        ></el-switch>
      </el-form-item>
      <el-form-item label="优先级" prop="programPriority">
        <el-input-number
          class="priority"
          :min="0" 
          :max="4" 
          v-model="ruleForm.programPriority"
          label="描述文字"
        >
        </el-input-number>
      </el-form-item>
      <el-form-item label="类型" prop="programType">
        <el-select @change="changeProgramType" v-model="ruleForm.programType" placeholder="请选择">
          <el-option
            v-for="item in programTypeOptions"
            :key="item.label"
            :label="item.value"
            :value="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Username属性" prop="programUserName">
        <el-input
          v-model="ruleForm.programUserName"
          :maxlength="32"
          placeholder="uid"
        ></el-input>
      </el-form-item>
      <el-form-item label="RDN属性" prop="programRdn">
        <el-input
          v-model="ruleForm.programRdn"
          placeholder="uid"
        ></el-input>
      </el-form-item>
      <el-form-item label="UUID 属性" prop="programUuid">
        <el-input
          v-model="ruleForm.programUuid"
          placeholder="entryUUID"
        ></el-input>
      </el-form-item>
      <el-form-item label="LDAP ObjectClass" prop="programObject">
        <el-input
          v-model="ruleForm.programObject"
          placeholder="inetOrgPerson, organizationalPerson"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="LDAP服务器  URL"
        class="testServer"
        prop="programTestServer"
      >
        <el-input
          class="testServerInput"
          v-model="ruleForm.programTestServer"
          placeholder="例如：ldap://172.19.63.60:389"
        ></el-input>
        <el-button
          @click="checkServer"
          type="primary"
          >测试链接</el-button
        >
      </el-form-item>
      <el-form-item label="Base DN" prop="programBaseDN">
        <el-input
          v-model="ruleForm.programBaseDN"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="User Object Filter" prop="programObjectFilter">
        <el-input
          v-model="ruleForm.programObjectFilter"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="安全类型" prop="safeType">
        <el-radio-group
          v-model="ruleForm.safeType"
        >
          <el-radio :label="1">不需要认证</el-radio>
          <el-radio :label="0">账号+密码</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="ruleForm.safeType === 0" label="管理员DN" prop="programDn">
        <el-input
          v-model="ruleForm.programDn"
          placeholder="例如：cn=adc"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="ruleForm.safeType === 0"
        label="密码"
        class="testServer"
        prop="testPassword"
      >
        <el-input
          type="password"
          class="testServerInput"
          placeholder=""
          auto-complete="new-password"
          v-model="ruleForm.testPassword"
          show-password
        ></el-input>
        <el-button
          type="primary"
          @click="checkPassword"
          >测试验证</el-button
        >
      </el-form-item>
      <el-form-item>
        <div class="footer">
          <el-button type="primary" @click="submitForm">确 定</el-button>
          <el-button @click="handleCancel">取 消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { validatePhone } from "@/common/utils.js"
import ContactAPIS from "@/apis/userContact.js"
export default {
  components: {},
  data() {
    const checkCountName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入程序显示名称"))
      } else {
        callback()
      }
    }
    return {
      rollTimer: null,
      breadcrumb: [
        {
          label: "用户联合",
          url: "/userContact"
        },
        {
          label: "新建用户联合"
        }
      ],
      programTypeOptions: [{
          value: 'LDAP',
          label: '0'
        }, {
          value: 'Active Directory',
          label: '1'
      }],
      topText: '用户联合配置错误会导致账户管理部分功能无法使用。请确认填写的配置信息无误后再保存。',
      moduleTitle: "新建用户联合",
      ruleForm: {
        programName: "",
        isEnable: true,
        programPriority: "",
        programType:"0",
        programUserName: "uid",
        programRdn: "uid",
        programUuid: "entryUUID",
        programObject: "inetOrgPerson, organizationalPerson",
        programTestServer: "",
        programBaseDN: "",
        programObjectFilter: "",
        safeType: 0,
        programDn: "",
        testPassword: ""
      },
      rules: {
        programName: [
          { required: true, validator: checkCountName, trigger: "blur" }
        ],
        programUserName: [{ required: true, message: "请输入UserName", trigger: ['blur', 'change']}],
        programRdn: [{ required: true, message: "请输入RDN", trigger: ['blur', 'change']}],
        programUuid: [{ required: true, message: "请输入UUID", trigger: ['blur', 'change'] }],
        programObject: [{ required: true, message: "请输入LDAP ObjectClass", trigger: ['blur', 'change'] }],
        programBaseDN: [{ required: true, message: "请输入Base DN", trigger: "blur" }],
        programDn: [{ required: true, message: "请输入管理员DN", trigger: "blur" }],
        programTestServer: [{ required: true, message: "请输入LDAP服务器 URL", trigger: "blur" }],
        testPassword: [{ required: true, message: "请输入密码", trigger: "blur" }],
        phone: [{ validator: validatePhone, trigger: "blur" }]
      },
      realmName: this.$realm //this.$realm,
    }
  },
  destroyed() {
    this.rollTimer = null
  },
  computed: {},
  mounted() {},
  methods: {
    // 获取部门列表
    async addUserContact() {
      let params = {
        ldapURL: this.ruleForm.programTestServer,
        managerDN: this.ruleForm.programDn,
        secret: this.ruleForm.testPassword,
        name: this.ruleForm.programName,
        enabled: this.ruleForm.isEnable,
        priority: this.ruleForm.programPriority,
        type: this.ruleForm.programType,
        usernameAttribute:this.ruleForm.programUserName,
        rdnAttribute:this.ruleForm.programRdn,
        uuidAttribute:this.ruleForm.programUuid,
        ldapObjectClass: this.ruleForm.programObject,
        baseDN: this.ruleForm.programBaseDN,
        userObjectFilter: this.ruleForm.programObjectFilter,
        authenticationType: this.ruleForm.safeType
      }
      let { status, data } = await ContactAPIS.postRealmsUserContact(this.realmName, {
        data: params
      })
      if (status === 0 && data && data.id) {
        this.$router.push({
          path: "/userContact/detailUserContact",
          query: {
            accountId: data.id,
            flag: "1"
          }
        })
      }else {
        this.$message.error({
          message: data
        })
      }
    },
    changeProgramType () {
      if(this.ruleForm.programType === '0'){
        this.ruleForm.programUserName = 'uid'
        this.ruleForm.programRdn = 'uid'
        this.ruleForm.programUuid = 'entryUUID'
        this.ruleForm.programObject = 'inetOrgPerson, organizationalPerson'
      } else {
        this.ruleForm.programUserName = 'cn'
        this.ruleForm.programRdn = 'cn'
        this.ruleForm.programUuid = 'objectGUID'
        this.ruleForm.programObject = 'person, organizationalPerson, user'
      }
    },
    async checkServer () {
      this.$refs["ruleFormAddCount"].validateField("programTestServer")
      this.testServer('0')
    },
    async testServer(flag) {
      if (this.ruleForm.programTestServer === '') {
        return
      }
      let params = {
        ldapURL: this.ruleForm.programTestServer
      }
      let { status, data } = await ContactAPIS.postTestServer(this.$realm, {
        data: params
      })
      if (status === 0 && flag === '0') {
        this.$message({
          message: 'LDAP服务器 URL验证成功',
          type: 'success'
        });
        return 'success'
      }else if (flag === '1' && status === 0) {
        /* donoting */
      }else{
        this.$message.error({
          message: data
        })
        return 'error'
      }
    },
    checkPassword () {
      this.$refs["ruleFormAddCount"].validateField("testPassword")
      this.testPassword('0')
    },
    async testPassword(flag) {
      if (this.ruleForm.testPassword === "") {
        return
      }
      let params = {
        ldapURL: this.ruleForm.programTestServer,
        managerDN: this.ruleForm.programDn,
        secret: this.ruleForm.testPassword
      }
      let { status, data } = await ContactAPIS.postTestPassword(this.$realm, {
        data: params
      })
      if (status === 0 && flag === '0') {
        this.$message({
          message: '密码验证成功',
          type: 'success'
        });
        return 'success'
      }else if (flag === '1' && status === 0) {
        /* donoting */
      }else{
        this.$message.error({
          message: data
        })
        return 'error'
      }
    },
    // 提交添加账户表单
    async submitForm() {
      this.$refs["ruleFormAddCount"].validate(valid => {
        if (valid) {
          this.addUserContact()
        } else {
          this.rollTimer = setTimeout(()=>{
            var isError= document.getElementsByClassName("is-error");
            isError[0].querySelector('input').focus();
          },100);
          return false;
        }
      })
    },
    handleCancel() {
      this.$router.push("/userContact")
    }
  }
}
</script>

<style lang="scss">
.addContactCount {
  .row-one {
    background-color: rgba(0, 112, 204, 0.05);
    height: 50px;
    padding: 0 15px;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin:0 0 25px 23px;
    color: #333333;
    .reUpload {
      color: #4497ec;
    }
    .icon-warning {
      margin-right: 8px;
    }
    .topText {
      i {
        font-style: normal;
        color: #4497ec;
        &.error {
          color: #d9001b;
        }
      }
    }
  }
  .el-alert--info{
    background:#f5f5f5 ;
    color:#454647;
    margin-bottom: 30px;
  }
  .el-form{
    width: 600px;
  }
  .name {
    margin-bottom: 16px;
    padding-left: 26px;
  }
  .el-form-item__error {
    white-space: nowrap;
  }
  .testServer{
    .el-button{
      position: absolute;
      top: 5px;
      right: 0;
    }
  }
  .el-form-item__content {
    .testTip {
      color: #999;
      font-size: 13px;
      margin-left: 20px;
      vertical-align: middle;
    }
    .el-button--text {
      position: absolute;
      margin-left: 14px;
      top: 6px;
    }
    .testServerInput{
      width: 350px;
    }
    .el-select{
      width: 100%;
    }
    .el-input-number{
      width: 100px;
    }
  }
}
</style>
